// @flow
import Loadable from '@src/components/Loadable';

export default Loadable({
  loader: () => import('./index.js'),
});
